import React from 'react';
import { cleanProps, IconProps } from './icon_props';

export const IconX = (props: IconProps) => {
  const clean = cleanProps(props);
  const { className, onClick, style } = clean;

  return (
    <svg style={style} onClick={onClick} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
      <g>
        <path d="M500,10C229.7,10,10,229.7,10,500s219.7,490,490,490s490-219.7,490-490S770.3,10,500,10z M774.6,660.5c31.2,31.2,31.2,82.9,0,114.2c-16.2,16.2-36.6,23.7-57.1,23.7c-20.5,0-40.9-7.5-57.1-23.7L500,614.2L339.5,774.6c-16.2,16.2-36.6,23.7-57.1,23.7s-40.9-7.5-57.1-23.7c-31.2-31.2-31.2-82.9,0-114.2L385.8,500L225.4,339.5c-31.2-31.2-31.2-82.9,0-114.2c31.2-31.2,82.9-31.2,114.2,0L500,385.8l160.5-160.5c31.2-31.2,82.9-31.2,114.2,0c31.2,31.2,31.2,82.9,0,114.2L614.2,500L774.6,660.5z" />
      </g>
    </svg>
  );
};
